<template>
  <div class="page">
    <div class="page-head">
      <div class="page-title">租赁房源</div>
      <el-button type="primary" size="small" icon="el-icon-plus" @click="openCreate">上架房源</el-button>
    </div>
    <el-form :inline="true" :model="query" class="toolbar">
      <el-form-item>
        <el-input v-model="query.keyword" size="small" clearable placeholder="标题 / 小区 / 位置"></el-input>
      </el-form-item>
      <el-form-item>
        <el-select v-model="query.city" size="small" clearable placeholder="城市">
          <el-option v-for="c in cities" :key="c" :label="c" :value="c"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select v-model="query.auditStatus" size="small" clearable placeholder="审核状态">
          <el-option label="待审核" value="待审核"></el-option>
          <el-option label="已通过" value="已通过"></el-option>
          <el-option label="已拒绝" value="已拒绝"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="search">查询</el-button>
        <el-button size="small" @click="reset">重置</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="list" border size="small" v-loading="loading">
      <el-table-column label="封面" width="80">
        <template slot-scope="scope">
          <img v-if="scope.row.cover" :src="scope.row.cover" class="cover" referrerpolicy="no-referrer" @error="onCoverError">
        </template>
      </el-table-column>
      <el-table-column prop="title" label="标题" min-width="150"></el-table-column>
      <el-table-column prop="city" label="城市" width="80"></el-table-column>
      <el-table-column prop="community" label="小区" width="120"></el-table-column>
      <el-table-column prop="rentType" label="类型" width="70"></el-table-column>
      <el-table-column prop="layout" label="户型" width="90"></el-table-column>
      <el-table-column prop="price" label="月租(元)" width="90"></el-table-column>
      <el-table-column prop="phone" label="电话" width="120"></el-table-column>
      <el-table-column label="提交用户" width="160">
        <template slot-scope="scope">
          <div class="submit-user">
            <img v-if="scope.row.userUrl" :src="scope.row.userUrl" class="avatar" referrerpolicy="no-referrer">
            <span v-else class="avatar-ph"></span>
            <span>{{ scope.row.userName || '—' }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="browseNumbers" label="浏览" width="70"></el-table-column>
      <el-table-column label="审核" width="90">
        <template slot-scope="scope">
          <el-tag size="mini" :type="auditTag(scope.row)">{{ auditLabel(scope.row) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="createdAt" label="提交时间" width="160" :formatter="fmtTime"></el-table-column>
      <el-table-column label="操作" width="220" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" size="mini" @click="openEdit(scope.row)">编辑</el-button>
          <el-button v-if="auditLabel(scope.row) === '待审核'" type="text" size="mini" @click="audit(scope.row, '已通过')">通过</el-button>
          <el-button v-if="auditLabel(scope.row) === '待审核'" type="text" size="mini" @click="audit(scope.row, '已拒绝')">拒绝</el-button>
          <el-button v-if="auditLabel(scope.row) === '已拒绝'" type="text" size="mini" @click="audit(scope.row, '已通过')">通过</el-button>
          <el-button v-if="auditLabel(scope.row) === '已通过'" type="text" size="mini" @click="offline(scope.row)">下架</el-button>
        </template>
      </el-table-column>
    </el-table>
    <Pagination :child-msg="pageparm" @callFather="onPage"></Pagination>

    <el-dialog :title="form.id ? '编辑房源' : '上架房源'" :visible.sync="dialogVisible" width="780px" top="4vh">
      <el-form :model="form" :rules="rules" ref="rentForm" label-width="100px" size="small">
        <el-form-item v-if="form.userName" label="提交用户">
          <div class="submit-user">
            <img v-if="form.userUrl" :src="form.userUrl" class="avatar" referrerpolicy="no-referrer">
            <span v-else class="avatar-ph"></span>
            <span>{{ form.userName }}</span>
          </div>
        </el-form-item>
        <el-row :gutter="12">
          <el-col :span="12">
            <el-form-item label="标题" prop="title">
              <el-input v-model="form.title" maxlength="40" placeholder="如 整租·2室1厅"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="城市" prop="city">
              <el-select v-model="form.city" placeholder="请选择" style="width:100%">
                <el-option v-for="c in cities" :key="c" :label="c" :value="c"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="小区" prop="community">
              <el-input v-model="form.community" placeholder="小区名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="位置" prop="near">
              <el-input v-model="form.near" placeholder="靠近地铁/商圈"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="出租类型" prop="rentType">
              <el-radio-group v-model="form.rentType" @change="syncTitle">
                <el-radio label="整租">整租</el-radio>
                <el-radio label="合租">合租</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="户型" prop="layout">
              <el-select v-model="form.layout" placeholder="请选择" style="width:100%" @change="syncTitle">
                <el-option v-for="item in layouts" :key="item" :label="item" :value="item"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="面积" prop="area">
              <el-input v-model="form.area" placeholder="m²">
                <template slot="append">m²</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="月租" prop="price">
              <el-input v-model="form.price" placeholder="元">
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="楼层" prop="floor">
              <el-input v-model="form.floor" placeholder="如 6层"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="朝向" prop="orient">
              <el-select v-model="form.orient" placeholder="请选择" style="width:100%">
                <el-option v-for="item in orients" :key="item" :label="item" :value="item"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="房屋类型">
              <el-select v-model="form.houseType" style="width:100%">
                <el-option label="公寓住宅" value="公寓住宅"></el-option>
                <el-option label="小区住宅" value="小区住宅"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="业态">
              <el-input v-model="form.kind" placeholder="如 小区住宅"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系电话" prop="phone">
              <el-input v-model="form.phone" maxlength="11"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="标签">
          <el-checkbox-group v-model="form.tags">
            <el-checkbox v-for="t in tagOptions" :key="t" :label="t">{{ t }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="租住状态">
          <el-checkbox-group v-model="form.status">
            <el-checkbox v-for="t in statusOptions" :key="t" :label="t">{{ t }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="房屋设施">
          <el-checkbox-group v-model="form.facilities">
            <el-checkbox v-for="t in facOptions" :key="t" :label="t">{{ t }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="房源图片">
          <el-upload
            list-type="picture-card"
            action="/api/tool/ossUpload"
            :headers="uploadHeaders"
            name="file"
            :file-list="fileList"
            :on-success="onUploadSuccess"
            :on-remove="onUploadRemove"
            :on-error="onUploadError"
            :limit="9">
            <i class="el-icon-plus"></i>
          </el-upload>
          <div class="upload-tip">也可直接填写图片地址，多张用英文逗号分隔</div>
          <el-input type="textarea" :rows="2" v-model="imageUrlsText" placeholder="https://xxx.jpg,https://yyy.jpg" @blur="applyImageUrls"></el-input>
        </el-form-item>
        <el-form-item label="房屋描述" prop="description">
          <el-input type="textarea" :rows="3" v-model="form.description" maxlength="300" placeholder="房屋优点、出租说明"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="dialogVisible = false">取消</el-button>
        <el-button size="small" type="primary" :loading="saving" @click="submit">保存上架</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Pagination from '../../components/Pagination'
import { rentPage, rentDetail, saveRent, offlineRent, auditRent, pageBody } from '../../api/spAdmin'
import citiesMixin from '../../mixins/cities'

function emptyForm() {
  return {
    id: '',
    title: '',
    city: '绥化',
    community: '',
    near: '',
    area: '',
    houseType: '公寓住宅',
    rentType: '整租',
    layout: '',
    price: '',
    tags: [],
    images: [],
    cover: '',
    orient: '',
    floor: '',
    kind: '小区住宅',
    status: ['随时可住', '预约看房'],
    facilities: [],
    description: '',
    phone: '',
    userName: '',
    userUrl: ''
  }
}

export default {
  components: { Pagination },
  mixins: [citiesMixin],
  data() {
    return {
      loading: false,
      saving: false,
      dialogVisible: false,
      list: [],
      query: { keyword: '', city: '', auditStatus: '' },
      pageparm: { currentPage: 1, pageSize: 10, total: 0 },
      layouts: ['1室1厅', '1室0厅', '2室1厅', '2室2厅', '3室1厅', '3室2厅', '4室2厅'],
      orients: ['朝东', '朝南', '朝西', '朝北', '东南', '南北', '东西'],
      tagOptions: ['押一付一', '年付', '月租', '可短租', '好停车', '可养宠物', '带阳台', '近地铁'],
      statusOptions: ['随时可住', '预约看房'],
      facOptions: ['床', '衣柜', '沙发', '电视', '洗衣机', '空调', '冰箱', '热水器'],
      form: emptyForm(),
      imageUrlsText: '',
      fileList: [],
      rules: {
        title: [{ required: true, message: '请填写标题', trigger: 'blur' }],
        city: [{ required: true, message: '请选择城市', trigger: 'change' }],
        community: [{ required: true, message: '请填写小区', trigger: 'blur' }],
        rentType: [{ required: true, message: '请选择类型', trigger: 'change' }],
        layout: [{ required: true, message: '请选择户型', trigger: 'change' }],
        price: [{ required: true, message: '请填写月租', trigger: 'blur' }],
        description: [{ required: true, message: '请填写描述', trigger: 'blur' }]
      }
    }
  },
  computed: {
    uploadHeaders() {
      return { token: localStorage.getItem('logintoken') || '' }
    }
  },
  created() { this.load() },
  methods: {
    fmtTime(row, col, val) {
      if (!val) return ''
      return String(val).replace('T', ' ').slice(0, 19)
    },
    auditLabel(row) {
      if (!row) return '待审核'
      if (row.enableType === false || row.enableType === 0 || row.enableType === '0') {
        if (row.checked !== true && row.checked !== 1) return '已拒绝'
      }
      if (row.checked === true || row.checked === 1) return '已通过'
      return '待审核'
    },
    auditTag(row) {
      const status = this.auditLabel(row)
      if (status === '已通过') return 'success'
      if (status === '已拒绝') return 'danger'
      return 'warning'
    },
    onCoverError(e) {
      e.target.style.opacity = '0.25'
    },
    search() {
      this.pageparm.currentPage = 1
      this.load()
    },
    reset() {
      this.query = { keyword: '', city: '', auditStatus: '' }
      this.search()
    },
    onPage(p) {
      this.pageparm.currentPage = p.currentPage
      this.pageparm.pageSize = p.pageSize
      this.load()
    },
    load() {
      this.loading = true
      rentPage({
        page: this.pageparm.currentPage,
        limit: this.pageparm.pageSize,
        keyword: this.query.keyword,
        city: this.query.city,
        auditStatus: this.query.auditStatus
      }).then(res => {
        if (!res || res.status !== 200) {
          this.list = []
          this.pageparm.total = 0
          this.loading = false
          this.$message.error((res && res.message) || '房源列表加载失败，请确认后端已重启')
          return
        }
        const body = pageBody(res)
        this.list = body.list
        this.pageparm.total = body.total
        this.loading = false
      }, () => { this.loading = false })
    },
    syncTitle() {
      if (this.form.rentType && this.form.layout) {
        this.form.title = this.form.rentType + '·' + this.form.layout
      }
    },
    openCreate() {
      this.form = emptyForm()
      this.imageUrlsText = ''
      this.fileList = []
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.rentForm && this.$refs.rentForm.clearValidate()
      })
    },
    openEdit(row) {
      rentDetail(row.id).then(res => {
        const data = (res && res.status === 200 && res.data) ? res.data : row
        this.form = Object.assign(emptyForm(), {
          id: data.id,
          title: data.title || '',
          city: data.city || '绥化',
          community: data.community || '',
          near: data.near || '',
          area: data.area,
          houseType: data.houseType || '公寓住宅',
          rentType: data.rentType || '整租',
          layout: data.layout || '',
          price: data.price,
          tags: data.tags || [],
          images: data.images || (data.cover ? [data.cover] : []),
          cover: data.cover || '',
          orient: data.orient || '',
          floor: data.floor || '',
          kind: data.kind || '小区住宅',
          status: data.status && data.status.length ? data.status : ['随时可住', '预约看房'],
          facilities: data.facilities || [],
          description: data.description || '',
          phone: data.phone || '',
          userName: data.userName || '',
          userUrl: data.userUrl || ''
        })
        this.syncFiles()
        this.dialogVisible = true
      })
    },
    syncFiles() {
      this.fileList = (this.form.images || []).map((url, i) => ({
        name: 'img' + i,
        url: url
      }))
      this.imageUrlsText = (this.form.images || []).join(',')
    },
    onUploadSuccess(res, file, fileList) {
      const url = res && res.data && res.data.url
      if (!url) {
        this.$message.error((res && res.message) || '图片上传失败，可改填图片地址')
        return
      }
      this.form.images = fileList.map(item => {
        if (item.response && item.response.data && item.response.data.url) {
          return item.response.data.url
        }
        return item.url
      }).filter(Boolean)
      this.form.cover = this.form.images[0] || ''
      this.imageUrlsText = this.form.images.join(',')
    },
    onUploadRemove(file, fileList) {
      this.form.images = fileList.map(item => {
        if (item.response && item.response.data && item.response.data.url) {
          return item.response.data.url
        }
        return item.url
      }).filter(Boolean)
      this.form.cover = this.form.images[0] || ''
      this.imageUrlsText = this.form.images.join(',')
    },
    onUploadError() {
      this.$message.error('图片上传失败，可在下方填写图片地址')
    },
    applyImageUrls() {
      const urls = (this.imageUrlsText || '').split(',').map(s => s.trim()).filter(Boolean)
      this.form.images = urls
      this.form.cover = urls[0] || ''
      this.fileList = urls.map((url, i) => ({ name: 'img' + i, url: url }))
    },
    submit() {
      this.$refs.rentForm.validate(valid => {
        if (!valid) return
        this.applyImageUrls()
        this.saving = true
        const payload = Object.assign({}, this.form, {
          area: this.form.area === '' ? null : Number(this.form.area),
          price: this.form.price === '' ? null : Number(this.form.price),
          images: this.form.images,
          cover: this.form.images[0] || this.form.cover
        })
        if (!payload.id) delete payload.id
        saveRent(payload).then(res => {
          this.saving = false
          if (res && res.status === 200) {
            this.$message.success('已保存')
            this.dialogVisible = false
            this.load()
          } else {
            this.$message.error((res && res.message) || '保存失败')
          }
        }, err => {
          this.saving = false
          this.$message.error((err && err.message) || '保存失败')
        })
      })
    },
    audit(row, status) {
      const tip = status === '已通过' ? '通过后将在小程序租房列表展示' : '拒绝后不会在小程序展示'
      this.$confirm(tip + '，确认？', '审核', { type: 'warning' }).then(() => {
        return auditRent(row.id, status)
      }).then(res => {
        if (res && res.status === 200) {
          this.$message.success('已更新')
          this.load()
        } else if (res) {
          this.$message.error(res.message || '审核失败')
        }
      }).catch(() => {})
    },
    offline(row) {
      this.$confirm('确认下架该房源？下架后小程序不再展示。', '提示', { type: 'warning' }).then(() => {
        return offlineRent(row.id)
      }).then(res => {
        if (res && res.status === 200) {
          this.$message.success('已下架')
          this.load()
        } else if (res) {
          this.$message.error(res.message || '下架失败')
        }
      }).catch(() => {})
    }
  }
}
</script>
<style scoped>
.page { padding: 8px 4px 24px; }
.page-head { display: flex; justify-content: space-between; align-items: center; margin-bottom: 16px; }
.page-title { font-size: 20px; font-weight: 800; color: #1f1633; }
.toolbar { background: #fff; padding: 12px 12px 0; border-radius: 16px; margin-bottom: 12px; }
.cover { width: 48px; height: 48px; object-fit: cover; border-radius: 6px; }
.submit-user { display: flex; align-items: center; }
.avatar, .avatar-ph { width: 28px; height: 28px; border-radius: 50%; margin-right: 8px; flex-shrink: 0; }
.avatar { object-fit: cover; }
.avatar-ph { background: #e8edf3; display: inline-block; }
.upload-tip { color: #909399; font-size: 12px; margin: 6px 0 8px; }
</style>



// WEBPACK FOOTER //
// src/views/housing/rentList.vue